import axios from "axios";
import { axiosWithKey } from '~/axios'
import { getToken} from '~/redux/user/tokens'


export function getEmailExists(email) {
  
  return getToken().then(token => {
     return axiosWithKey.post('/identity/email',
          {
            email: email,
          	headers:{
            		Authorization: token
          	}
        })
        .then(response => {
        	return response.data.email != undefined;
        })
        .catch(error => {
        	if(error.response.status === 404){
        		return false;
        	}else{
        		console.log('There was an error finding this email: ' + email)
        		console.log(error);
        	}
        });
  });
}

export function validateCustomerCard(mercadoToken, site, email, userId, publicKey, paymentMethodId, issuerId) {
	return getToken().then(token => {
		return axios({
			method: "POST",
			url: `${
				window.settings.apiBaseUrl
			}/payments/mercadopago/validate_customer`,
			params: { site: site, platform: "web_browser" },
			headers: {
				Authorization: token,
				"x-api-key": window.settings.baseAPIKey
			},
			data: {
				mercadopagoToken: mercadoToken,
				site: site,
				email: email,
				userId: userId,
				publicKey: publicKey,
				paymentMethodId: paymentMethodId,
				issuerId: issuerId
			}
		})
		.then(res=>{
			return res;
		})
		.catch(error=>{
			return error.response;
		})
	})
}